import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Action pour créer un avis
export const createReview = createAsyncThunk(
  "reviews/create",
  async (reviewData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}reviews`;
      const response = await axios.post(apiUrl, reviewData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      // console.error("API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

const reviewSlice = createSlice({
  name: "reviews",
  initialState: {
    reviews: [], // Liste des avis (optionnel, si vous voulez stocker les avis)
    status: "idle", // Statut de la création d'avis
    error: null, // Erreur de la création d'avis
  },
  reducers: {
    clearReview: (state) => {
      state.reviews = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createReview.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createReview.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Optionally store the created review in the state
        state.reviews = [...state.reviews, action.payload];
      })
      .addCase(createReview.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Erreur inconnue";
      });
  },
});

// Sélecteurs
export const selectReviewStatus = (state) => state.reviews.status;
export const selectReviewError = (state) => state.reviews.error;
export const selectReviews = (state) => state.reviews.reviews;

// Export des actions et du reducer
export const { clearReview } = reviewSlice.actions;
export default reviewSlice.reducer;